var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsulting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0661 11.0668C13.39 8.74517 17.1695 8.74517 19.4905 11.0668L25.8164 17.3931L30.0786 11.6898L23.6237 9.78848L20.187 0L12.8474 4.29721L3.44071 3.43925L3.43958 3.43852V3.43925H3.43745L3.43958 3.44137L4.29582 12.8485L0 20.187L9.78742 23.6234L11.6898 30.0786L17.3931 25.816L11.0668 19.4912C8.74411 17.1695 8.74411 13.39 11.0661 11.0668Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9117 27.6521L18.1208 12.8625C16.6702 11.4104 14.3157 11.4104 12.8639 12.8625C11.4125 14.3139 11.4125 16.6673 12.8639 18.1202L27.6541 32.9104C29.1077 34.3618 31.4592 34.3618 32.9128 32.9104C34.3624 31.4568 34.3635 29.1048 32.9117 27.6521ZM16.8533 19.3236L14.2569 16.7265C13.9141 16.3811 13.7465 15.9413 13.7465 15.4899C13.7465 15.04 13.9134 14.6002 14.2559 14.2549C14.6016 13.9123 15.0428 13.7437 15.4931 13.7437C15.943 13.7422 16.3843 13.9123 16.729 14.2563L19.325 16.8526L16.8533 19.3236Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting2);
export default __webpack_public_path__ + "static/media/consulting-2.d2f61b865eda26fa01680ec788c48433.svg";
export { ForwardRef as ReactComponent };